import React, { useEffect } from "react";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/standard-button";
import Popup from "@atlaskit/popup";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import ExcelSpreadsheet16Icon from "@atlaskit/icon-file-type/glyph/excel-spreadsheet/16";
import Document16Icon from "@atlaskit/icon-file-type/glyph/document/16";
import RetryIcon from "@atlaskit/icon/glyph/retry";

import styles from "./RestoreExportFooter.module.css";

const RestoreExportFooter = (props) => {
  // const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {}, [props.formStateData]);

  return (
    <>
      <ButtonGroup className={styles.buttons}>
        <Button
          iconBefore={<RetryIcon label="Reset" size="medium" />}
          isDisabled={props.isLoading}
          appearance="default"
          id="mapFieldsReset"
          onClick={props.handleFormReset}
        >
          Reset
        </Button>

        <Popup
          isOpen={props.isOpen}
          onClose={() => props.setIsOpen(false)}
          placement="bottom-start"
          content={() => (
            <div className={styles.content}>
              <ButtonGroup appearance="subtle">
                <Button
                  spacing="compact"
                  iconBefore={<Document16Icon label="Download JSON" />}
                  onClick={() => {
                    props.handleExportData("json");
                    props.setIsOpen(false);
                  }}
                >
                  JSON
                </Button>
                <Button
                  spacing="compact"
                  iconBefore={<ExcelSpreadsheet16Icon label="Download CSV" />}
                  onClick={() => {
                    props.handleExportData("csv");
                    props.setIsOpen(false);
                  }}
                >
                  CSV
                </Button>
              </ButtonGroup>
            </div>
          )}
          trigger={(triggerProps) => (
            <Button
              {...triggerProps}
              iconBefore={<ArrowDownIcon label="Export Issues" size="medium" />}
              appearance="primary"
              isSelected={props.isOpen}
              isDisabled={props.isLoading}
              type="submit"
            >
              Export Issues
            </Button>
          )}
        />
      </ButtonGroup>
    </>
  );
};

export default RestoreExportFooter;
